export enum WhiteListType {
  FILE_CHARACTERISTICS = 1,
  FILE_PATH = 2,
  FILE_FOLDER = 3
}
export enum Status {
  PENDING = 'PENDING',             // 等待执行
  RUNNING = 'RUNNING',       // 正在执行
  COMPLETED = 'COMPLETED',        // 执行成功结束
  FAILED = 'FAILED',   // 执行失败结束
  TIMEDOUT = 'TIMEDOUT',    // 执行超时
  CANCELED = 'CANCELED'     // 取消执行
}
export const titleLabel = {
  1: '文件特征',
  2: '文件路径',
  3: '文件目录',
}
// 1~3分别表示 WhiteListType枚举值，二级1～2表示各个类型的1：新增，2:删除
export const handleCustomOperateType = (type: 1 | 2 | 3, subType: 1 | 2) => {
  const types = {
    '1_1': 1,
    '1_2': 2,
    '2_1': 3,
    '2_2': 4,
    '3_1': 5,
    '3_2': 6,
  }
  return types[type + '_' + subType]
}
export const labelTip = {
  1: ['1.同一文件重复上传时，系统将自动去重；', '2.如终端文件的文件特征变更，旧的加白项将失效，请及时检查并重新添加；'],
  2: ['1.通过添加绝对路径的单个文件进行加白,例如D:\\Test\\test.exe；', '2.如终端文件的文件路径变更，旧的加白项将失效，请及时检查并重新添加；'],
  3: ['1.添加文件目录时，尽量不要添加高风险目录，例如：C:\\Users\\用户名\\Downloads；', '2.如文件目录变更，旧的加白项将失效，请及时检查并重新添加；'],
}
export const file_key = {
  1: 'signs',
  2: 'files',
  3: 'dirs'
}
export const file_pattern = {
  1: /^[a-f0-9]{32}$/,
  2: /^(?:[a-zA-Z]:)?(?:\\|\/)(?:[^<>:"|?*]+(?:\\|\/))*[^<>:"|?*]+(?![\\\/])$|^(?:\/[^\/<>:"|?*]+)+(?:\/[^\/<>:"|?*]+)*$/,
  3: /^(?:[a-zA-Z]:)?(?:\\|\/)(?:[^<>:"|?*]+(?:\\|\/))*[^<>:"|?*]+(?![\\\/])$|^(?:\/[^\/<>:"|?*]+)+(?:\/[^\/<>:"|?*]+)*$/
}
